import PropTypes from 'prop-types';
import capitalize from '../../helpers/capitalize';

export default function InputType({ inputTitle, inputValue, isValid, maxCharLength, onInputChange, errorMessage }) {
  return (
    <div className="modal-input-body-type">
      <div className="modal-input-title">{inputTitle}</div>
      <textarea className="modal-input" value={inputValue} onChange={onInputChange} />
      <div className="modal-input-info">
        <div className="modal-error">{errorMessage ? capitalize(`${inputTitle} is ${errorMessage}`) : null}</div>
        <div className={isValid ? '' : 'modal-error'}>{`${inputValue.length}/${maxCharLength}`}</div>
      </div>
    </div>
  );
}

InputType.propTypes = {
  errorMessage: PropTypes.string.isRequired,
  inputTitle: PropTypes.string.isRequired,
  inputValue: PropTypes.string.isRequired,
  isValid: PropTypes.bool.isRequired,
  maxCharLength: PropTypes.number.isRequired,
  onInputChange: PropTypes.func.isRequired,
};
